/// Tema da interface. Ver a versão gêmea em apps/site/src/tema.ts.
///
/// Três estados, não dois. "Sistema" segue a preferência do aparelho e é o
/// padrão. No galpão isso importa mais que no escritório: com a luz baixa, a
/// tela clara ofusca; com sol na bancada, a escura some.
export type Tema = "sistema" | "claro" | "escuro";

const CHAVE = "bipagem.tema";

export function temaAtual(): Tema {
  const guardado = localStorage.getItem(CHAVE);
  return guardado === "claro" || guardado === "escuro" ? guardado : "sistema";
}

/// "Sistema" REMOVE o atributo em vez de escrever um valor: é a ausência dele
/// que deixa o `prefers-color-scheme` do CSS decidir.
export function aplicarTema(tema: Tema): void {
  const raiz = document.documentElement;

  if (tema === "sistema") raiz.removeAttribute("data-theme");
  else raiz.setAttribute("data-theme", tema === "escuro" ? "dark" : "light");

  localStorage.setItem(CHAVE, tema);

  // A barra de status do celular acompanha, senão fica um recorte claro no
  // topo de uma tela escura.
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    const escuro = raiz.getAttribute("data-theme") === "dark";
    meta.setAttribute("content", escuro || tema === "sistema" ? "#15170e" : "#f7f5ec");
  }
}

export function iniciarTema(): void {
  aplicarTema(temaAtual());
}

export const OPCOES: Array<{ valor: Tema; rotulo: string; icone: string }> = [
  { valor: "sistema", rotulo: "Automático", icone: "◐" },
  { valor: "claro", rotulo: "Claro", icone: "☀" },
  { valor: "escuro", rotulo: "Escuro", icone: "☾" },
];
